import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { DatePicker } from "@mui/lab";
import { Button, Drawer, Stack, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { useState } from "react";
import TimePicker from "@mui/lab/TimePicker";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const useStyles = makeStyles(() => ({
  root: {
    flexShrink: 0,
  },
  date1: { border: "1px solid red" },
}));

function AddOutage({
  open,
  rowOutage,
  SaveChanges,
  onClose,
}: {
  open: boolean;
  rowOutage: any;
  SaveChanges: any;
  onClose: any;
}) {
  const classes = useStyles();
  const [openDrawer, SetOpenDrawer] = React.useState<any>(open);
  const [tag, SetTag] = React.useState<any>("");
  const [currentRow, SetCurrentRow] = useState([] as any);

  function OnSaveClick() {
    SaveChanges(currentRow);
  }
  React.useEffect(() => {
    if (open == true) {
      const cloneRow = { ...rowOutage };
      if (cloneRow.outageDate != null) {
        const d = new Date(cloneRow.outageDate);
        d.setMinutes(d.getMinutes() + new Date().getTimezoneOffset());
        cloneRow.outageDate = d;
      }
      SetCurrentRow(cloneRow);
    }
    SetOpenDrawer(open);
  }, [open]);

  function SetValue(key: string, value: any) {
    currentRow[key] = value;
    SetTag(new Date().getMilliseconds());
  }

  return (
    <Box>
      <Drawer
        PaperProps={{ style: { width: "auto" } }}
        anchor="right"
        open={openDrawer}
        onClose={() => onClose(0)}
        variant={"temporary"}
      >
        <Box style={{ padding: "5px 10px", marginTop: "15px" }}>
          <Box style={{ width: "100%" }}>
            <Box style={{ marginTop: "20px" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Product Type
                </InputLabel>
                <Select
                  label="Product Type"
                  onChange={(e: any) => {
                    SetValue("productType", e.target.value);
                  }}
                >
                  <MenuItem value="Ideal">Ideal</MenuItem>
                  <MenuItem value="Infinity">Infinity</MenuItem>
                  <MenuItem value="Aspen">Aspen</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["year", "month", "day"]}
                  className={classes.date1}
                  label="Outage Date"
                  value={currentRow.outageDate}
                  onChange={(value: any) => {
                    SetValue("outageDate", value);
                  }}
                  renderInput={(params: any) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Box>
            <Box style={{ marginTop: "12px" }}>
              <TextField
                required
                id="outlined-required"
                label="Environment"
                defaultValue={currentRow.environment}
                onChange={(e: any) => {
                  SetValue("environment", e.target.value);
                }}
                style={{ width: "300px" }}
              />
            </Box>
            <Box sx={{ minWidth: 20, marginTop: "12px" }}>
              <TextField
                required
                id="filled-number"
                label="Dealers Affected"
                defaultValue={currentRow.dealersAffected}
                onChange={(e: any) => {
                  SetValue("dealersAffected", e.target.value);
                }}
                type="number"
                variant="outlined"
              />
            </Box>
            <Box sx={{ minWidth: 20, marginTop: "12px" }}>
              <TextField
                required
                id="filled-number"
                label="Time to Escalate"
                defaultValue={currentRow.escalateTime}
                onChange={(e: any) => {
                  SetValue("escalateTime", e.target.value);
                }}
                type="number"
                variant="outlined"
              />
            </Box>
            <Box sx={{ minWidth: 20, marginTop: "12px" }}>
              <TextField
                required
                id="filled-number"
                label="Ack Escalate Time"
                defaultValue={currentRow.ackEscalateTime}
                onChange={(e: any) => {
                  SetValue("ackEscalateTime", e.target.value);
                }}
                type="number"
                variant="outlined"
              />
            </Box>
            <Box sx={{ minWidth: 20, marginTop: "12px" }}>
              <TextField
                required
                id="filled-number"
                label="Time to Resolve"
                defaultValue={currentRow.resolveTime}
                onChange={(e: any) => {
                  SetValue("resolveTime", e.target.value);
                }}
                type="number"
                variant="outlined"
              />
            </Box>
            <Box sx={{ minWidth: 20, marginTop: "12px" }}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox/>
                  }
                  label="Customer Reported Incident"
                  onChange={(e: any) => {
                    SetValue("customerReportedIncident", e.target.checked);
                  }}
                />
              </FormGroup>
            </Box>
            <Box style={{ marginTop: "12px" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  label="OutageStartTime"
                  value={currentRow.outageStartTime}
                  onChange={(value: any) => {
                    SetValue("outageStartTime", value);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Box>
            <Box style={{ marginTop: "12px" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  label="OutageEndTime"
                  value={currentRow.outageEndTime}
                  onChange={(value: any) => {
                    SetValue("outageEndTime", value);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Box>
            <Box style={{ marginTop: "12px" }}>
              <TextareaAutosize
                required
                aria-label="minimum height"
                minRows={3}
                defaultValue={currentRow.summary}
                placeholder="Summary"
                onChange={(e: any) => {
                  SetValue("summary", e.target.value);
                }}
                style={{ width: 300, height: 100 }}
              />
            </Box>
            <Box style={{ marginTop: "12px" }}>
              <TextareaAutosize
                required
                aria-label="minimum height"
                minRows={3}
                defaultValue={currentRow.rootCause}
                placeholder="Root Cause"
                onChange={(e: any) => {
                  SetValue("rootCause", e.target.value);
                }}
                style={{ width: 300, height: 100 }}
              />
            </Box>
            <Box style={{ marginTop: "12px" }}>
              <TextareaAutosize
                required
                aria-label="minimum height"
                minRows={3}
                defaultValue={currentRow.resolution}
                placeholder="Resolution"
                onChange={(e: any) => {
                  SetValue("resolution", e.target.value);
                }}
                style={{ width: 300, height: 100 }}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ padding: "10px", border: "0px solid red" }}
          >
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={OnSaveClick}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
export default AddOutage;
